import React, { ReactElement, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";

interface ProtectedRouteProps {
    children: ReactElement;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
    // Initialize `isAllowed` directly based on the session storage value
    const [isAllowed, setIsAllowed] = useState(() => {
        const allowAppendixForm = sessionStorage.getItem("allowAppendixForm");
        return allowAppendixForm === "true";
    });

    useEffect(() => {
        // Optional: Clear the flag after it's been checked
        sessionStorage.removeItem("allowAppendixForm");
    }, []);

    if (!isAllowed) {
        return <Navigate to="/" replace />;
    }

    return children;
};

export default ProtectedRoute;
